import { useEffect, useState } from "react";
import { Filter, X } from "lucide-react";
import { api } from "@/lib/api";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";

export function LayerFilter({ layer, filter, onChange }) {
  const [fields, setFields] = useState(null);
  const [open, setOpen] = useState(!!filter);

  useEffect(() => { if (open && !fields) api.get(`/map/layers/${layer.id}/fields`).then(({ data }) => setFields(data)).catch(() => setFields([])); }, [open, fields, layer.id]);

  const field = fields?.find((f) => f.name === filter?.field);

  if (!open) {
    return (
      <button type="button" data-testid={`layer-filter-toggle-${layer.id}`} title="Filter by attribute" aria-label={`Filter ${layer.name}`} onClick={() => setOpen(true)}
        className={`w-7 h-7 rounded-full grid place-items-center hover:bg-emerald-100 dark:hover:bg-slate-800 ${filter ? "text-terracotta" : "text-emerald-800 dark:text-emerald-300"}`} style={filter ? { color: "var(--terracotta)" } : {}}><Filter size={14} /></button>
    );
  }
  return (
    <div data-testid={`layer-filter-${layer.id}`} className="w-full mt-1 ml-6 rounded-xl bg-muted/70 p-2 flex flex-col gap-2 text-xs">
      <div className="flex items-center justify-between"><span className="font-mono uppercase tracking-wider text-[10px] text-muted-foreground">Filter {layer.name}</span>
        <button type="button" aria-label="Close filter" onClick={() => { setOpen(false); onChange(null); }} className="text-muted-foreground hover:text-foreground"><X size={12} /></button></div>
      {fields === null && <span className="text-muted-foreground">Loading fields…</span>}
      {fields?.length === 0 && <span className="text-muted-foreground">No filterable attributes.</span>}
      {fields?.length > 0 && (
        <div className="grid grid-cols-2 gap-2">
          <Select value={filter?.field || ""} onValueChange={(v) => onChange({ field: v, value: null })}>
            <SelectTrigger data-testid={`layer-filter-field-${layer.id}`} className="h-8 rounded-lg text-xs bg-card"><SelectValue placeholder="Field" /></SelectTrigger>
            <SelectContent className="z-[1300]">{fields.map((f) => <SelectItem key={f.name} value={f.name}>{f.name} <span className="text-muted-foreground">({f.distinct})</span></SelectItem>)}</SelectContent>
          </Select>
          <Select value={filter?.value ?? ""} onValueChange={(v) => onChange({ field: filter.field, value: v === "__all__" ? null : v })} disabled={!field}>
            <SelectTrigger data-testid={`layer-filter-value-${layer.id}`} className="h-8 rounded-lg text-xs bg-card"><SelectValue placeholder="Value" /></SelectTrigger>
            <SelectContent className="z-[1300] max-h-64">
              <SelectItem value="__all__">All values</SelectItem>
              {field?.values.map((v) => <SelectItem key={v} value={v}>{v}</SelectItem>)}
            </SelectContent>
          </Select>
        </div>
      )}
    </div>
  );
}
